import { createFeatureSelector, createSelector } from "@ngrx/store";
import { featureKey, State } from "./live-lesson-state.reducer";

const selectFeatureState = createFeatureSelector<State>(featureKey);

export const selectLiveLessonState = createSelector(
    selectFeatureState,
    (state) => state.liveLessonState
);
